import React from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { useLoading } from "@hooks";
import { Modal } from "@lib/modal";

import { getCurrentCulture } from "@utils";
import { useAppActionsContext, useAppContext } from "@state/hooks/shared";

const availableLanguages = [
	// { value: 'es', name: 'Español' },
	// { value: 'nl', name: 'Dutch' },
	{ value: "en", name: "English" },
	{ value: "de", name: "Deutsch" },
	{ value: "fr", name: "Français" },
	{ value: "hr", name: "Hrvatski" },
	{ value: "it", name: "Italiano" },
	{ value: "tr", name: "Türkçe" },
	{ value: "sq", name: "Shqip" },
	{ value: "sv", name: "Svenska" },
	{ value: "da", name: "Dansk" },
];

export function LanguagesSelector(props: {
	setIsLanguagesSelectorOpen: (value: boolean) => void;
	isLanguagesSelectorOpen: boolean;
}) {
	const { pathname, search } = useLocation();
	const { t, i18n } = useTranslation();
	const { culture } = useAppContext();
	// const [language, setLanguage] = useState(null);
	const methods = useForm({
		mode: "onChange",
		defaultValues: { languageGroup: culture },
	});
	const { handleSubmit, register, setValue } = methods;
	const { setIsLanguagesSelectorOpen, isLanguagesSelectorOpen } = props;

	const { setCulture } = useAppActionsContext();

	const { setIsLoading } = useLoading();

	if (!isLanguagesSelectorOpen) {
		return null;
	}
	methods.watch("languageGroup");
	const onCultureChange = (data: { languageGroup: string }) => {
		const { languageGroup } = data;
		const currentLanguageGroup = getCurrentCulture();

		if (languageGroup == currentLanguageGroup) {
			setIsLanguagesSelectorOpen(false);
			return;
		}
		setIsLanguagesSelectorOpen(false);
		setIsLoading(true);
		setCulture(languageGroup);
		i18n.changeLanguage(languageGroup);
		setIsLoading(false);
		let segments: string[] = pathname.split("/");
		segments[1] = languageGroup;
		window.location.replace(segments.join("/") + search);
	};

	return (
		<Modal>
			<div className="at-LanguagesSelector popup">
				<FormProvider {...methods}>
					<form
						className="popup__card"
						onSubmit={handleSubmit(onCultureChange)}
					>
						<div className="popup__header">
							{t<string>("SUBHEADER.LANGUAGES.SET_LANGUAGE")}
						</div>
						<div className="popup__body">
							<ul className="popup__list">
								{availableLanguages.map((x) => (
									<li key={x.value} className="input--radio">
										<input
											{...register("languageGroup")}
											id={x.value}
											className="input--radio__box"
											type="radio"
											value={x.value}
											onChange={(e) =>
												setValue(
													"languageGroup",
													e.target.value
												)
											}
										/>
										<label htmlFor={x.value}>
											<i
												className={`u-icon u-icon--med u-icon--lang u-icon--lang--${x.value} u-align--v--middle u-mar--right--xtny`}
											/>
											<span className="input--radio__label">
												{x.name}
											</span>
										</label>
									</li>
								))}
							</ul>
						</div>
						<div className="popup__footer">
							<button
								type="button"
								onClick={() =>
									setIsLanguagesSelectorOpen(false)
								}
								className="popup__btn popup__btn--secondary btn btn--med btn--block btn--primary--inverted"
								data-at="at-LanguageSelector__btn--secondary"
							>
								{t<string>("COMMON.CANCEL_BUTTON")}
							</button>
							<button
								type="submit"
								className="popup__btn popup__btn--primary btn btn--med btn--block btn--accent"
								data-at="at-LanguageSelector__btn--primary"
							>
								{t<string>("COMMON.OK_BTN")}
							</button>
						</div>
					</form>
				</FormProvider>
			</div>
		</Modal>
	);
}
